import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { validateShineConnection } from '../query-api'

interface UseValidateShineConnectionProps {
  onError?: (error: APIError) => void
  onSuccess?: () => void
}

export interface ShineConnectionValidationParams {
  code: string
  globalOrgId: string
  globalUserId: string
  organizationId: string
  state: string
}

export const useValidateShineConnection = (props?: UseValidateShineConnectionProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: validate,
    isLoading: isProcessing,
    data,
    ...rest
  } = useMutation(
    ({ organizationId, globalOrgId, globalUserId, code, state }: ShineConnectionValidationParams) =>
      validateShineConnection({
        organizationId,
        payload: {
          globalOrgId,
          globalUserId,
          callback: `${window.location.origin}/product/shine/callback`,
          code,
          state,
        },
      }),
    {
      onSuccess,
      onError,
    },
  )

  return {
    isProcessing,
    validate,
    data,
    ...rest,
  }
}
